import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";

const StreamEndPopup = ({ open, handleClose }) => {
  return (
    <Dialog open={open} onClose={handleClose} className="text-center delete-popup-box">
      <DialogTitle>Stream Ended</DialogTitle>
      <DialogContent>
        <p>The stream has ended. Thank you for watching!</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Leave
        </Button>
      </DialogActions>
    </Dialog>
  );
};


export const EndlivePopUp = ({open,handleClose ,onClose}) => {
    return (
        <Dialog open={open} onClose={handleClose} className="text-center delete-popup-box">
          <DialogTitle>Stream Ended</DialogTitle>
          <DialogContent className="pb-0">
            <p>Are you sure you want to end live</p>
          </DialogContent>
          <DialogActions className="d-flex justify-content-center mb-3 btn-box">

          <Button onClick={onClose} className="btn pop-btn">
              Cancel
            </Button>

            <Button onClick={handleClose} className="primary-btn pop-btn">
              End Live
            </Button>
          </DialogActions>
        </Dialog>
      );
    };
    

export default StreamEndPopup;
